/**
 * Mobile menu dropdown.
 *
 * The header renders a hamburger (`#toggle-menu`, visible below lg) and the nav
 * (`.desktop-menu`, hidden below lg via `.show-lg-up`). Clicking the hamburger
 * reveals the nav on mobile.
 *
 * `.show-lg-up` sets `display: none !important` below 992px (see
 * global/_responsive.scss), which a normal jQuery slideToggle can't beat — so
 * we toggle visibility with an *important* inline style, and clear it (plus the
 * trigger's active state) on resize up to desktop so nothing lingers open.
 */
import $ from 'jquery';

export default function initMenu(): void {
    const trigger = document.getElementById('toggle-menu');
    const nav = document.querySelector<HTMLElement>('.header .desktop-menu');

    if (!trigger || !nav) {
        return; // header/nav not on this page
    }

    const close = (): void => {
        nav.style.removeProperty('display');
        trigger.classList.remove('active');
    };

    trigger.addEventListener('click', (event) => {
        event.preventDefault();
        const isOpen = trigger.classList.toggle('active');
        if (isOpen) {
            nav.style.setProperty('display', 'block', 'important');
        } else {
            nav.style.removeProperty('display');
        }
    });

    // Close on resize so the menu never stays open when switching to the
    // desktop layout (where the nav is shown by its own utility class).
    $(window).on('resize', close);
}
